// English comments only.
// Tiny runtime config reader. Safe if window.__APP_CONFIG__ is missing.

export type AppConfig = {
  imageBase?: string; // e.g. https://imagemadmax.info
};

declare global {
  interface Window {
    __APP_CONFIG__?: AppConfig;
  }
}

/** Read config from window (injected by /app-config.js). */
export function getAppConfig(): AppConfig {
  if (typeof window !== 'undefined' && window.__APP_CONFIG__) {
    return window.__APP_CONFIG__ as AppConfig;
  }
  return {};
}

/** Convenience getter for image base URL (without trailing slash). */
export function getImageBaseFromRuntime(): string | undefined {
  const v = (getAppConfig().imageBase || '').trim();
  if (!v) return undefined;
  return v.replace(/\/+$/, '');
}
